module.exports = __webpack_public_path__ + "static/media/join-cover.39a35c52.png";